import L, { Map } from 'leaflet';
import { MapController } from 'src/app/components/LeafletMapComponent/controllers/MapController';
import { LeafletEventsType } from 'src/app/components/LeafletMapComponent/leaflet.config';

export class DrawController extends MapController {
  drawController: L.Control.Draw | undefined;

  editableLayers: L.FeatureGroup | undefined;

  drawColor = '#ff0000';

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(map: Map, drawOptions?: L.Control.DrawConstructorOptions, events?: LeafletEventsType) {
    super(map);

    this.setDrawController(drawOptions);
    this.bindEvents(events);
    this.setDrawOptions();

    // this.placeTextPopup("TCG", [0, 0]);

    // @ts-ignore

    // @ts-ignore
    // this.map.addControl(MapPaint.SwitchControl());
  }

  /**
   * Sets drawing control plugin to be used and
   */
  setDrawController = (drawOptions?: L.Control.DrawConstructorOptions) => {
    this.editableLayers = L.featureGroup();

    // this.editableLayers.on("click", (e: L.LeafletEvent) => {
    //   console.log("EditableLayer Click", e);
    // });

    // this.editableLayers.on("touchstart", (e) => {
    //   console.log("EditableLayers Touch Start", e);
    // });

    this.map.addLayer(this.editableLayers);

    const defaultDrawOptions: L.Control.DrawConstructorOptions = {
      position: 'topleft',
      edit: {
        featureGroup: this.editableLayers,
        remove: true,
      },
    };

    this.drawController = new L.Control.Draw(drawOptions ? { ...drawOptions } : { ...defaultDrawOptions });

    this.map.addControl(this.drawController);
    // this.map.addControl(new CustomColorPicker());

    // const domCustomColorPicker = document.querySelector("#customColorPicker");
    // (domCustomColorPicker as HTMLInputElement).addEventListener(
    //   "input",
    //   (e) => {
    //     // @ts-ignore
    //     this.drawColor = e.target.value;
    //     this.setDrawOptions();
    //   }
    // );
  };

  /**
   * binds events.
   */
  bindEvents = (events?: LeafletEventsType) => {
    // @ts-ignore
    this.map.on(L.Draw.Event.CREATED, (e: L.DrawEvents.Created) => {
      const { layer } = e;

      //   layer.bindPopup(ReactDOMServer.renderToString(<ObjectTextPopup isEditing data={undefined} />), {
      //     closeOnClick: false,
      //     minWidth: 300,
      //   });
      // console.log(getMiddlePoint(layer));
      this.editableLayers?.eachLayer((layerObj) => this.editableLayers?.removeLayer(layerObj));
      events?.onDrawCompleted(e);
      this.editableLayers?.addLayer(layer);

      layer.openPopup();

      // console.log('Layer Added ', layer, e);

      //   layer.on("click", (mouseEvent: L.LeafletMouseEvent) => {
      //     console.log("Layer clicked", mouseEvent);
      //   });

      //   // @ts-ignore
      //   layer.on("touchstart", (touchStartEvent: L.LeafletMouseEvent) => {
      //     console.log("Layer touchstart", touchStartEvent);
      //   });
    });

    // this.map.on(L.Draw.Event.DRAWSTOP, (e: any) => {
    //   console.log('DRAWSTOP', e);
    // });
  };

  setDrawOptions = () => {
    this.drawController?.setDrawingOptions({
      polyline: {
        drawError: {
          message: 'Failed to draw polyine',
        },
        showLength: true,
        shapeOptions: {
          color: this.drawColor,
        },
      },
      polygon: {
        allowIntersection: false,
        drawError: {
          message: 'Failed to draw polygon',
        },
        showArea: true,
        shapeOptions: {
          color: this.drawColor,
        },
      },
      circle: {
        showRadius: true,
        shapeOptions: {
          color: this.drawColor,
        },
      },
      circlemarker: {
        color: this.drawColor,
      },
      rectangle: {
        shapeOptions: {
          color: this.drawColor,
        },
      },
      // marker: false,
    });
  };

  placeTextPopup = (text: string, position: L.LatLngExpression) => {
    L.popup({
      closeButton: false,
      autoClose: false,
      className: 'leaflet-text-popup',
    })
      .setLatLng(position)
      .setContent(`<p>${text}</p>`)
      .openOn(this.map);
  };
}
